const MuiButtonGroupOverrides = {
  MuiButtonGroup: {
    defaultProps: {
      variant: 'contained',
      disableElevation: true,
      disableRipple: true
    },
    styleOverrides: {
      contained: () => ({
        alignItems: 'center',
        '.MuiButtonGroup-grouped:not(:last-of-type), .MuiButtonGroup-grouped:not(:last-of-type).Mui-disabled': {
          border: 0
        }
      })
    }
  }
};

export { MuiButtonGroupOverrides };
